import { CellData, NO_DATA_CELL, ProgressBar } from './ProgressBar';
import {
  GoalProgressMetrics,
  ProgressPortraitMetrics,
} from '../model/ProgressPortrait';
import {
  formatDateMMddYYYY,
  MetricProgressBar,
  toProgressSegments,
} from '../utils/utils';
import React from 'react';
import { CellTooltip, TooltipItem } from './CellTooltip';

const extractGoalMetricsData = (
  progressPortraitMetrics: ProgressPortraitMetrics,
) => progressPortraitMetrics.goals;

const toCellData = (goalData: GoalProgressMetrics): CellData => {
  if (!(goalData.reportDate && goalData.percentage)) {
    return NO_DATA_CELL;
  }
  const tooltip = <GoalTooltip goal={goalData} />;
  if (goalData.percentage <= 49) {
    return {
      label: 'Below 50%',
      level: 'low',
      tooltip: tooltip,
    };
  }
  if (goalData.percentage < 76) {
    return {
      label: '50-75%',
      level: 'medium',
      tooltip: tooltip,
    };
  }
  return {
    label: 'Above 75%',
    level: 'high',
    tooltip: tooltip,
  };
};

export const GoalProgressMetric = ({
  progressPortraitMetrics,
}: MetricProgressBar) => {
  const segments = toProgressSegments(
    progressPortraitMetrics,
    extractGoalMetricsData,
    toCellData,
  );
  return <ProgressBar segments={segments} />;
};

const GoalTooltip = ({
  goal,
}: {
  goal: GoalProgressMetrics;
}): React.ReactElement => {
  const info: TooltipItem[] = [
    {
      label: 'Client Report Received Date:',
      value: formatDateMMddYYYY(goal.reportDate),
    },
    {
      label: '% of client goals mastered:',
      value: `${Math.round(goal.percentage)}%`,
    },
    {
      label: 'Total client goals:',
      value: goal.totalGoals,
    },
    {
      label: 'Client goals met:',
      value: goal.goalsMet,
    },
    {
      label: 'Total caregiver training goals:',
      value: goal.totalCaregiverTrainingGoals,
    },
    {
      label: 'Caregiver training goals met:',
      value: goal.caregiverTrainingGoalsMet,
    },
    {
      label: 'New goals:',
      value: goal.newGoalsForNextReportingPeriod,
    },
  ];
  return <CellTooltip info={info} />;
};
